import {customLog} from "./../../customLog.js";
import {combineReducers} from "redux";
import * as globalActions from "../actions/globalActions";

export const fetchReducer = (state=[], action) =>
{
	var newState = Object.assign([], state);
	
	switch(action.type)
	{
		case globalActions.addFetching:
			newState.push(action.payload.key);
			break;
		case globalActions.removeFetching:
			newState = newState.filter((elem)=>{return elem != action.payload.key});
			break;

		default:
			return state;
	}
	return newState;
}


export const consoleReducer = (state={messages:[], show:false}, action) =>
{
	const newState = Object.assign({}, state);
	var logChanged = false;

	switch(action.type)
	{
		case globalActions.addLogMessage:
			logChanged = true;
			var logMsg = {msg:action.payload, time:Date.now()};
			newState.messages = [...newState.messages, logMsg];
			break;

		case globalActions.keepLogClean:
			newState.messages = newState.messages.filter((msg)=>msg.time > action.payload);
			logChanged = newState.messages.length != state.messages.length;

			break;
		case globalActions.addSelectedIdToLog:
			logChanged = true;
			logMsg = {msg:action.payload.selectedId, time:Date.now()};
			newState.messages = [...newState.messages, logMsg];
			break;

		case globalActions.k_setSetShowLog:
			newState.show = action.payload.show;
			logChanged = newState.show != state.show;
			
			break;
	}
	return logChanged ? newState : state;
}

export const unitReducer = (state={geolocation:null}, action) =>
{
	switch(action.type)
	{
		case globalActions.k_setGeoLocationData:
		return Object.assign({}, state ? state : {}, {geolocation:action.payload});
	}
	return state;
}

/*
export const audioReducer = (state={}, action) =>
{
	
	switch(action.type)
	{
		case globalActions.setAudioAvailability:
			const newVar = {};
			newVar[action.payload.fileName] = {availabilityState:action.payload.availabilityState, progress: action.payload.progress, transferID: action.payload.transferId};
			return Object.assign({}, state, newVar);

		case globalActions.clearAudioAvailability:
		return {};
	}
	return state;
}
*/




// WEBPACK FOOTER //
// ./js/stateStuff/reducers/globalReducers.js